import React from 'react'
import { Grid, Box } from '@mui/material';
import ComplianceMetrc from './Compliance'
import DeliveryMetrc from './DeliveryFee'
import MemberMetrc from './MemberMetrc'

const FeeManagement = () => {
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <ComplianceMetrc/>
        </Grid>
        <Grid item xs={12} md={6}>
          <DeliveryMetrc/>
        </Grid>
        <Grid item xs={12} md={12}>
          <MemberMetrc/>
        </Grid>
      </Grid>
    </>
  )
}

export default FeeManagement
